var map = {
	"./avatar.png": 236,
	"./favicon.ico": 573,
	"./load-vue.gif": 574,
	"./login/login-bg.jpg": 238,
	"./login/login-logo.png": 239,
	"./none_data.png": 237,
	"./sidebar/sidebar-logo.png": 196
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 572;